<header>
    <div class="text" mat-dialog-title>
        <div class="title">Hi {{ user.name }}! Welcome to myVirtualCare</div>
    </div>
    <button mat-icon-button class="header" (tapped)="close()">
        <app-icon [icon]="{ type: 'icon', class: 'material-icons', content: 'close' }"></app-icon>
    </button>
</header>
<mat-dialog-content>
    <main>
        <div class="subtitle">We have a few extra questions for you to get ready!</div>
        <form [formGroup]="form">
            <div class="field-group mb-1">
                <img src="assets/img/time.svg" />
                <div class="field">
                    <label
                        >What is {{ user.type === 'patient' ? 'your' : 'the' }} appointment
                        time?</label
                    >
                    <div
                        class="input"
                        (tapped)="toggleTimePicker()"
                        a-tooltip
                        [(show)]="show_picker"
                        [content]="time_picker"
                        position="below"
                        offset="start"
                    >
                        <div class="time">
                            {{ appointment_time ? (appointment_time | showTime) : 'Unscheduled' }}
                        </div>
                        <div class="icon">
                            <i class="material-icons">keyboard_arrow_down</i>
                        </div>
                    </div>
                </div>
                <ng-template #time_picker>
                    <div class="time-picker">
                        <time-picker
                            [time]="appointment_time"
                            (timeChange)="changeTime($event)"
                            (event)="closeTimePicker()"
                        >
                        </time-picker>
                    </div>
                </ng-template>
            </div>
            <div class="field-group" *ngIf="user.type !== 'patient'">
                <div class="icon icon-field"><i class="material-icons">person</i></div>
                <div class="field">
                    <label for="patient_name">Patient Name</label>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="patient_name" type="text" placeholder="Patient Name here..."/>
                    </mat-form-field>
                </div>
            </div>
            <div class="field-group mb-1" *ngIf="user.type !== 'patient'">
                <div class="icon icon-field"><i class="material-icons">person_add</i></div>
                <div class="field">
                    <label for="with_patient">Is the patient with you?</label>
                    <mat-radio-group formControlName="with_patient">
                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                        <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div
                class="field-group mb-0"
                *ngIf="
                    user.type !== 'employee' &&
                    room.list_member_names &&
                    room.list_member_names.length
                "
            >
                <img src="assets/img/clinician.svg" />
                <div class="field">
                    <label for="clinician"
                        >Who is {{ user.type === 'patient' ? 'your' : "the patient's" }} clinician
                        for today?</label
                    >
                    <mat-form-field appearance="outline">
                        <input type="text"
                               placeholder="Select clinician"
                               matInput
                               formControlName="clinician"
                               [matAutocomplete]="auto" />
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="clinicianName">
                            <mat-option *ngFor="let clinic of filteredClinicians | async" [value]="clinic">
                                {{ clinic.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div
                class="field-group"
                *ngIf="user.type === 'employee' || user.type === 'another provider'"
            >
                <div class="icon icon-field"><i class="material-icons">label</i></div>
                <div class="field">
                    <label for="job_title">What is your role? (Job Title)</label>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="job_title" type="text" placeholder="Job Title here..."/>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </main>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button name="accept" [disabled]="!form.valid" (tapped)="accept()">Enter</button>
</mat-dialog-actions>
